import { GroupID } from "./GroupID";

// API: SlideCategory / SlideCategoryRef / SlideDefs (RehnRestAPI/Models/Slides.vb)
export interface SlideCategory {
	categoryID: string;
	categoryName: string;
	categoryDescription: string;
	categoryGroups?: GroupID[];
	color?: string;
	/** Number of presentations referencing the category. Returned by getDefs. */
	presentationCount?: number;
}

export interface SlideCategoryRef {
	categoryID: string;
	categoryName: string;
	color?: string;
}

export interface SlideDefs {
	categories: SlideCategory[];
}

export const emptySlideDefs: SlideDefs = { categories: [] };
